<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                Upload File
            </h2>
            <v-form name="editForm" ref="editForm">
                <v-container>
                    <v-row class>
                        <v-col>
                            <v-text-field
                                v-model="modelObject.name"
                                label="Title"
                                outlined
                                dense
                                hide-details
                                :rules="[rules.required]"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-file-input
                                v-model="modelObject.file_name"
                                outlined
                                label="File"
                                dense
                                hide-details
                                :rules="[rules.required]"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'

export default {
    name: "FileManagerModal",
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    components: {
    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            dialog: this.value || false,
            modelObject: {},
            modelDefault: {
                name: null,
                file_name: null,
            },
            saveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
        }
    },
    methods: {
        resetModel() {
            this.modelObject = structuredClone(this.modelDefault)
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            if (this.$refs.editForm.validate()) {
                let formData = new FormData()
                let item = this.modelObject
                for (let key in item) {
                    if (item[key] !== null && item[key] !== undefined && item[key] !== 'undefined') {
                        formData.append(key, item[key])
                    } else {
                        formData.append(key, '')
                    }
                }

                let url = route('filemanagers.store')

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('File has been uploaded')
                            this.$root.is_dirty = false
                            this.saveLoading = false
                            this.dialog = false
                            this.$emit('updated')
                        } else if (response.data?.error) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error)
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },

    },
    computed: {
        dialog_width() {
            return '50%'
        },
        // is_edit_mode() {
        //     return this.mode == 'Edit' ? true : false
        // }
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === true) {
                // Opening
                this.resetModel()
            } else {
                this.$emit('closeDialog')
            }
        },
    },
}
</script>

<style>

</style>
